import { string, object } from 'yup';

const schema = object().shape({
  name: string().required('Name is required')
});

export default { create: schema, edit: schema };
